<ng-template #tourStepContent>
  <div class="tour-step-header">
    <div class="tour-step-header-title">{{ 'qz-tour-zm' | translate }}</div>
    <div class="tour-step-header-dismiss">
      <rcp-button-icon-only color="guaranteed-on-dark" (click)="dismissAll()" [icon]="faTimes"></rcp-button-icon-only>
    </div>
  </div>
  <div class="tour-step-content">
    <ng-content></ng-content>
  </div>
  <div class="tour-step-footer">
    <div class="steps-navigation">
      @if (tourStepNavigate(); as tourStepNavigate) {
        @if (tourStepNavigate.hasPrevious) {
          <rcp-button-icon-only
            color="guaranteed-on-dark"
            (click)="previousStep()"
            [icon]="faAngleLeft"
          ></rcp-button-icon-only>
        }
        @if (tourStepNavigate.totalStepsNumber > 1) {
          <div class="steps-text">
            {{ tourStepNavigate.currentStepNumber }} / {{ tourStepNavigate.totalStepsNumber }}
          </div>
        }
        @if (tourStepNavigate.hasNext) {
          <rcp-button-icon-only
            color="guaranteed-on-dark"
            (click)="nextStep()"
            [icon]="faAngleRight"
          ></rcp-button-icon-only>
        } @else {
          <rcp-button color="primary" (click)="dismissAll()">
            {{ 'qz-got-it-zm' | translate }}
          </rcp-button>
        }
      }
    </div>
  </div>
</ng-template>
